export const DEFAULT_PAGE_SIZE = 30;
export const DEFAULT_MAX_ROWS = 30;
